import {
   ANNUAL_MILEAGE_OPTIONS,
   CAR_INSURANCE_COVERAGE_TYPE_OPTIONS, CAR_USAGE_TYPE_OPTIONS_CAR_INSURANCE,
   insurancePaymentTypes,
   NO_CLAIMS_DISCOUNT_OPTIONS,
   PARKING_DURING_DAY_OPTIONS,
   PARKING_DURING_NIGHT_OPTIONS,
   VOLUNTARY_EXCESS_AMOUNT_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";

import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import ScrollableCustomDateTimePickerBlock
   from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import ScrollableCheckBoxListBlock from "@components/common/form-blocks/scrollable/checkbox-list-block";

export default function CarUsage({data, handlers, setCurrentStep}) {

    return (
        <div className="car-usage">

            <SectionHeading
                text="Car Usage"
            />


            <div className="row">

                {/* Where's the car kept during the day? */}

                <ScrollableDropdownBlock
                    controlName="carParkingAtDay"
                    containerCssClass="col-12 py-3 "
                    labelText="Where's the car kept during the day?"
                    required={true}
                    options={PARKING_DURING_DAY_OPTIONS}
                    selectedValues={data.carParkingAtDay}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                <ScrollableDropdownBlock
                    controlName="carParkingAtNight"
                    containerCssClass="col-12 py-3 "
                    labelText="Where's the car kept during the day?"
                    required={true}
                    options={PARKING_DURING_NIGHT_OPTIONS}
                    selectedValues={data.carParkingAtNight}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Is the car kept at the same address? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Is the car kept at the same address?"
                    required={true}
                    controlName="isCarKeptOnSameAddress"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.isCarKeptOnSameAddress}
                    onChange={handlers.onControlChange}
                />


                {data.isCarKeptOnSameAddress === 'No' && (

                    <>
                        {/* If No, what is the full address of where the car is kept? */}

                        <ScrollableTextBoxBlock
                            containerCssClass="col-12 py-3 "
                            labelText="If No, what is the full address of where the car is kept?"
                            required={data.isCarKeptOnSameAddress === 'No'}
                            controlName="carKeeperAddress"
                            value={data.carKeeperAddress}
                            onChange={handlers.onControlChange}
                            inputAttrs={{
                                maxLength: 50,
                                rows: 4
                            }}
                            asTextArea={true}
                        />
                    </>

                )}

                {/*  Have you or any of the drivers ever had insurance declined, cancelled or special terms
                        imposed? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 "
                    labelText=" Have you or any of the drivers ever had insurance declined, cancelled or special terms imposed?"
                    required={true}
                    controlName="wasInsuranceDeclinedBefore"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.wasInsuranceDeclinedBefore}
                    onChange={handlers.onControlChange}
                />

                {data.wasInsuranceDeclinedBefore === 'Yes' && (

                    <>
                        {/* What is the name of insurer? */}

                        <ScrollableTextBoxBlock
                            containerCssClass="col-12 py-3 "
                            labelText="What is the name of insurer?"
                            required={true}
                            controlName="insurerName"
                            value={data.insurerName}
                            onChange={handlers.onControlChange}
                            inputAttrs={{
                                maxLength: 50
                            }}
                        />

                    </>

                )}

                {/* Use of Car */}

                {/*<ScrollableDropdownBlock
                    controlName="carUsageType"
                    containerCssClass="col-12 py-3 "
                    labelText="Use of car"
                    required={true}
                    options={CAR_USAGE_TYPE_OPTIONS}
                    selectedValues={data.carUsageType}
                    onChange={handlers.onControlChange}
                    helpText=""
                />*/}
               
               <ScrollableCheckBoxListBlock
                  labelText={ "Use of car"}
                  dataBlock={`carUsageTypes`}
                  options={CAR_USAGE_TYPE_OPTIONS_CAR_INSURANCE}
                  required={true}
                  selectedValues={data.carUsageTypes}
                  controlName={`carUsageTypes[]`}
                  controlId={`carUsageTypes-`}
                  onChange={handlers.onControlChange}
                  inlineCheckBoxes={false}
                  
               />

                {/* Estimated annual mileage */}

                <ScrollableDropdownBlock
                    controlName="estimatedAnnualMileage"
                    containerCssClass="col-12 py-3 "
                    labelText="Estimated annual mileage"
                    required={true}
                    options={ANNUAL_MILEAGE_OPTIONS}
                    selectedValues={data.estimatedAnnualMileage}
                    onChange={handlers.onControlChange}
                    helpText=""
                />


                {/* Type of cover */}

                <ScrollableDropdownBlock
                    controlName="insuranceCoverageType"
                    containerCssClass="col-12 py-3 "
                    labelText="Type of cover"
                    required={true}
                    options={CAR_INSURANCE_COVERAGE_TYPE_OPTIONS}
                    selectedValues={data.insuranceCoverageType}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Any no claim discount? */}

                <ScrollableDropdownBlock
                    controlName="noClaimsDiscount"
                    containerCssClass="col-12 py-3 "
                    labelText="Any no claim discount?"
                    required={true}
                    options={NO_CLAIMS_DISCOUNT_OPTIONS}
                    selectedValues={data.noClaimsDiscount}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* What voluntary excess would you like? */}

                <ScrollableDropdownBlock
                    controlName="voluntaryExcessAmounts"
                    containerCssClass="col-12 py-3 "
                    labelText="What voluntary excess would you like?"
                    required={false}
                    options={VOLUNTARY_EXCESS_AMOUNT_OPTIONS}
                    selectedValues={data.voluntaryExcessAmounts}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* How do you normally pay for insurance? */}

                <ScrollableDropdownBlock
                    controlName="insurancePaymentType"
                    containerCssClass="col-12 py-3 "
                    labelText="How do you normally pay for insurance?"
                    required={true}
                    options={insurancePaymentTypes}
                    selectedValues={data.insurancePaymentType}
                    onChange={handlers.onControlChange}
                    helpText=""
                />

                {/* Please provide your current/previous insurer’s name */}

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Please provide your current/previous insurer’s name"
                    required={false}
                    controlName="insurerName"
                    value={data.insurerName}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

                {/*  How much was your renewal price with the previous insurer ? */}

                <ScrollableTextBoxBlock
                    type="number"
                    containerCssClass="col-12 py-3 "
                    labelText=" How much was your renewal price with the previous insurer ?"
                    required={false}
                    controlName="renewalPriceOfPreviousInsurer"
                    value={data.renewalPriceOfPreviousInsurer}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />


                {/* When do you want the insurance to start ? */}

                <ScrollableCustomDateTimePickerBlock
                    containerCssClass="col-12 py-3 "
                    labelText="When do you want the insurance to start ?"
                    required={true}
                    controlName="insuranceCoverageStartDate"
                    value={data.insuranceCoverageStartDate}
                    onChange={handlers.onControlChange}
                />
                
            </div>
        </div>
    );

}